/* eslint-disable react/jsx-props-no-spreading -- Dropzone owns the native input and drag/drop event bindings. */
import React from 'react';
import { useDropzone } from 'react-dropzone';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import { MAX_VIDEO_MEDIAFILE_SIZE, VIDEO_MEDIA_ACCEPT } from '@shared/config/media';
import { toast } from '@shared/ui';
import type { VideoPromoUploaderProps } from './types';
import { TEXTS } from './texts';
import styles from './index.module.scss';

const VideoPromoUploader: React.FC<VideoPromoUploaderProps> = ({ elementId, isDisabled, onFilesSelected }) => {
  const { open, getInputProps, getRootProps } = useDropzone({
    accept: VIDEO_MEDIA_ACCEPT,
    maxSize: MAX_VIDEO_MEDIAFILE_SIZE,
    minSize: 1,
    disabled: isDisabled,
    noClick: true,
    noKeyboard: true,
    multiple: true,
    onDrop: onFilesSelected,
    onDropRejected: () => toast.error(TEXTS.INVALID),
  });
  return (
    <div {...getRootProps({ className: styles.root })}>
      <Button
        elementId={`${elementId}_button`}
        type={ButtonType.SECONDARY}
        isDisabled={isDisabled}
        onClick={open}>
        {TEXTS.UPLOAD}
      </Button>
      <input
        {...getInputProps()}
        data-testid={`${elementId}_input`}
      />
      <p className={styles.hint}>{TEXTS.FORMATS}</p>
    </div>
  );
};

export default VideoPromoUploader;
